type GraphqlError = {
  readonly message?: string;
};

type GraphqlResponse<TData> = {
  readonly data?: TData;
  readonly errors?: ReadonlyArray<GraphqlError>;
};

const ENDPOINT = "https://promaster-publish.panasonic.divid.se/graphql/f83bb8f8-030a-4df2-ba4e-5ad57aa41ff1/localhost";

export async function requestGraphql<TData, TVariables extends Record<string, unknown>>(
  query: string,
  variables: TVariables
): Promise<TData> {
  const response = await fetch(ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ query, variables }),
  });

  if (!response.ok) {
    throw new Error(`Unable to load data (${response.status} ${response.statusText})`);
  }

  let payload: GraphqlResponse<TData>;
  try {
    payload = (await response.json()) as GraphqlResponse<TData>;
  } catch {
    throw new Error("Bad response.");
  }

  if (payload.errors && payload.errors.length > 0) {
    const firstMessage = payload.errors[0]?.message ?? "Unknown GraphQL error";
    throw new Error(`Unable to load data: ${firstMessage}`);
  }

  if (!payload.data) {
    throw new Error("Bad response.");
  }

  return payload.data;
}
